import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string): void => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20">
      <div className="text-center z-[2] max-w-4xl px-8">
        <h1 className="font-orbitron text-[clamp(3rem,8vw,6rem)] font-black mb-4 leading-tight">
          <span className="bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent drop-shadow-[0_0_40px_rgba(99,102,241,0.5)] animate-glow-pulse">
            KinkAsylum
          </span>
        </h1>
        <p className="text-2xl text-text-secondary mb-4">
          Alliance Code: <strong className="text-primary-light font-orbitron text-3xl tracking-[3px]">knki</strong>
        </p>
        <p className="text-xl text-text-secondary mb-8 leading-relaxed">
          A powerful alliance in the Last War universe. United we stand, divided we fall.
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <button
            className="btn btn-primary md:w-auto w-full"
            onClick={() => scrollToSection('join')}
          >
            Join the Alliance
          </button>
          <button
            className="btn btn-secondary md:w-auto w-full"
            onClick={() => scrollToSection('about')}
          >
            Learn More
          </button>
        </div>
      </div>
      <div className="absolute top-0 left-0 right-0 bottom-0 z-[1] overflow-hidden">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary rounded-full opacity-60 shadow-[0_0_10px] shadow-primary animate-float"
            style={{
              left: `${10 + i * 20}%`,
              animationDelay: `${i * 2}s`,
              animationDuration: `${15 + i * 2}s`,
            }}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
